import { render, staticRenderFns } from "./FloatBall.vue?vue&type=template&id=246e744c&scoped=true&"
import script from "./FloatBall.vue?vue&type=script&lang=js&"
export * from "./FloatBall.vue?vue&type=script&lang=js&"
import style0 from "./FloatBall.vue?vue&type=style&index=0&id=246e744c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e744c",
  null
  
)

export default component.exports